import { render, staticRenderFns } from "./AppLayoutRegisterLogin.vue?vue&type=template&id=1cd53b26&scoped=true&"
import script from "./AppLayoutRegisterLogin.vue?vue&type=script&lang=js&"
export * from "./AppLayoutRegisterLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutRegisterLogin.vue?vue&type=style&index=0&id=1cd53b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd53b26",
  null
  
)

export default component.exports